<template>
  <svg
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_731_92550)">
      <path
        d="M6 28C6 14.7452 16.7452 4 30 4H52.1538C53.1735
        4 54 4.82655 54 5.84615V28C54 41.2548 43.2548 52 30 52C16.7452 52 6 41.2548 6 28Z"
        fill="url(#paint0_radial_731_92550)"
      />
      <g clip-path="url(#clip0_731_92550)">
        <g filter="url(#filter1_d_731_92550)">
          <path
            d="M34.25 23.75L25.75 32.25M25.75 23.75L34.25 32.25"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_731_92550"
        x="0"
        y="0"
        width="60"
        height="60"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="3" />
        <feComposite
          in2="hardAlpha"
          operator="out"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.101961 0 0 0 0 0.392157 0 0 0 0 0.831373 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_731_92550"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_731_92550"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_731_92550"
        x="20.75"
        y="20.75"
        width="18.5"
        height="18.5"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite
          in2="hardAlpha"
          operator="out"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.2 0 0 0 0 0.67451 0 0 0 0 0.992157 0 0 0 0.3 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_731_92550"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_731_92550"
          result="shape"
        />
      </filter>
      <radialGradient
        id="paint0_radial_731_92550"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(28.3842 51.34) rotate(-89.1963) scale(10.7084 61.6941)"
      >
        <stop
          offset="0"
          stop-color="#528EE9"
        />
        <stop
          offset="1"
          stop-color="#145ECE"
        />
      </radialGradient>
      <clipPath id="clip0_731_92550">
        <rect
          width="17"
          height="17"
          fill="white"
          transform="translate(21.5 19.5)"
        />
      </clipPath>
    </defs>
  </svg>
</template>